import React, {useEffect, useState} from 'react';
import * as ServerComms from '../utilities/ServerComms';
import * as CoreFns from '../utilities/CoreFns';
import * as SearchForAnEntityType from '../utilities/SearchForAnEntityType';
import * as ClickElement from './ClickElement';
import * as ActionModifiers from '../ActionModifiers';
import * as BaseItems from '../utilities/BaseItems';
import ElementLeftScrollDisplay from './ElementLeftScrollDisplay';
import ColorBar from './ColorBar';

function App(props) {

  var itemT = props.itemT;
  var addPath = props.addPath;
  var position = props.position;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var clickBack = props.clickBack;
  var setItemEdited = props.setItemEdited;
  var userNos = props.userNos;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;
  var width = props.width;
  var palette = props.palette;
  var height = props.height;
  var userID = props.userID;
  var signKey = props.signKey;
  var sessionID = props.sessionID;
  var chains = props.chains;
  var changeTab = props.changeTab;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var refObject = props.refObject;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var hidePanelRelativeItems = props.hidePanelRelativeItems;
  var setHidePanelRelativeItems = props.setHidePanelRelativeItems;
  var feedSource = props.feedSource;

  const [templates, setTemplates] = useState([]);

  const [colorCombo, setColorCombo] = useState(0);
  const [counter, setCounter] = useState(0);
  var cust = ActionModifiers.createNull();  
  const [customColorRecord, setCustomColorRecord] = useState(cust);
  const [isShowingCustom, setIsShowingCustom] = useState(false);

  function incrementCounter(){
    setCounter(counter + 1);
  }

  function getItemTemplates(){
    function postGetTemplates1(response){
      var ins = response.v.map((aN, index)=>{
        return {v:JSON.parse(aN.v[0].v), d:aN.v[1].v, as:JSON.parse(aN.v[2].v)};
      })
      setTemplates(ins);
    }
    if (feedSource > 0){
      ServerComms.fetchSomething({u:'getItemTemplates', feedSource, userID, signKey, sessionID}, postGetTemplates1);
    }else if (itemT === 'BUTTON'){
      var abi = CoreFns.getContractInfoAbi(currentList, feedSource);
      var ins1 = [];
      abi.forEach((aAbi, index)=>{
        if (aAbi.type === 'function' && aAbi.stateMutability !== 'view'){
          var b = BaseItems.getBaseConstruct(itemT, 0)
          b.s.text = aAbi.name;
          var ph = 'existingContractFn ' + feedSource + ' ' + aAbi.name + ' ' + aAbi.inputs.length;
          b.oc = {click:{t:ph}}
          ins1.push({as:{}, d:aAbi.name, v:b})
        }
      })
      setTemplates(ins1);
    }
  }

  useEffect(()=>{
    getItemTemplates();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!currentList){
    return <div></div>
  }
//
  function clickItem(itemSet){
    return function(e){
      ClickElement.clickItem(itemSet, currentList, itemT, doingWhat, setDoingWhat, addPath, chains, setIsClickingOnContentDiv, userNos, organicChanges, setItemEdited, changeTab, setIsShowingSomeDropDown, hidePanelRelativeItems, setHidePanelRelativeItems, position, insetWidth, insetHeight, refObject);
      e.stopPropagation();
      clickBack();
      clickBack();
    }

  }

  var components = ActionModifiers.getColorComponents(isShowingCustom, customColorRecord, palette, colorCombo);

  var modOptions = [];
  var possibs = SearchForAnEntityType.searchEntity(currentList, itemT); 
  var items = [];
  if (feedSource === -1){
    items = possibs.map((aPossib, index)=>{
      return {v:aPossib.item, as:currentList.as, d:''};
    })
  }else if (feedSource === -2){
    if (currentList.cn){
      var existingCNs = Object.keys(currentList.cn);
      existingCNs.forEach((aCN, index)=>{
        var thisPiece = JSON.parse(JSON.stringify(currentList.cn[aCN].nv));
        thisPiece.on = 1;
        thisPiece.origRef = aCN;
        items.push({v:thisPiece, d:'Common Nav Bar : ' + currentList.cn[aCN].n, as:currentList.as, cn:currentList.cn});
      })
    }

  }else{
    function compare(a, b) {
      return a.d.localeCompare(b.d, 'en', { numeric: true })
    }
    var tt = JSON.parse(JSON.stringify(templates));
    items = tt.sort(compare);

    tt.forEach((aTemplate, index)=>{
      var thisAlert = aTemplate.v;
      var type = 'item';
      var pp = ActionModifiers.goThroughAnItem([], thisAlert, type, 'selectNew', components, currentList, chains, changeTab);
      modOptions = modOptions.concat(pp);
    })

  }

  var cut = 0;
  var botHeight = height - 100;

   var styleBar = null;
   if (modOptions.length > 0){
    cut = 200;
    styleBar = <ColorBar colorCombo={colorCombo} setColorCombo={setColorCombo} incrementCounter={incrementCounter}  customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom} modOptions={modOptions} palette={palette} counter={counter} height={botHeight}/>
   }


  var itemShow = <ElementLeftScrollDisplay chains={chains} items={items} clickItem={clickItem} itemT={itemT} addPath={addPath} width={width} height={botHeight} insetWidth={insetWidth} insetHeight={insetHeight} currentList={currentList} organicChanges={organicChanges} counter={counter}/>
  var itemName = CoreFns.getElementInfo(itemT).t;
// , border:'1px solid blue'
  return <div style={{width}} ><center>
    <p className='lead mb-0'>Add {itemName}</p>
    <table style={{width, height:botHeight}}><tbody><tr><td style={{verticalAlign:'top', height:botHeight, width:width-cut}}><center>
    {itemShow}
    </center></td>
    {styleBar}
    </tr></tbody></table>
    </center>
    </div>
}
//
export default App;
